import React, {useRef} from 'react';
import classNames from "classnames";
import {Form, Formik} from "formik";
import FieldInput from "../../../../common/components/FieldInput";
import FieldDatepicker from "../../../../common/components/FieldDatepicker";
import FieldSelect from "../../../../common/components/FieldSelect";
import ModalCommon from "../../../../common/components/ModalCommon";
import ButtonCommon from "../../../../common/components/ButtonCommon";
import {ddOptions} from "../../../../common/constants/options";
import {
  allowFloatWithDecimals,
  divideThousandsIntegerValue,
  formatStringToNumber
} from "../../../../common/utils/formatting";
import {
  limitFloatValueLength,
  limitIntegerValueLength
} from "../../../../common/utils/form/limitValueLength";
import view from 'common/assets/visibility-24px.svg';
import styles from './styles.module.scss';

const ModalViewOriginalRow = ({gridName, cities, streets, updateStreets, getOriginal, originID, id, row}) => {
  const formikCommonRef = useRef(null);
  const formikSurveyRef = useRef(null);
  const formikTaxAuthorityRef = useRef(null);

  const getContent = () => {
    switch (gridName) {
      case 'tax':
        return (
          <Formik
            innerRef={formikTaxAuthorityRef}
            initialValues={{
              ...row,
              saleDate: row?.saleDate ?? null,
              city: row?.city && Array.isArray(cities)
                ? cities.find(item => item.label === row?.city) ?? null : null,
              street: row?.street && Array.isArray(streets)
                ? streets.find(item => item.label === row?.street) ?? null : null,
            }}
            onSubmit={() => {
            }}
            enableReinitialize={true}
          >
            {({values}) => (
              <Form>
                <div className={styles.taxAuthorityForm}>
                  <div className={styles.threeInRow}>
                    <FieldInput fieldId="gushHelkaTtHelka" label="גוש וחלקה" disabled={true}/>
                    <FieldDatepicker
                      fieldId="saleDate"
                      label={'תאריך עסקה'}
                      datepickerStyles={styles.datepicker}
                      boxStyles={styles.datepicker}
                      disabled={true}
                    />
                  </div>
                  <div className={styles.threeInRow}>
                    <FieldSelect
                      fieldId="city"
                      value={values.city}
                      placeholder="עיר"
                      label={'עיר'}
                      options={cities}
                      disabled={true}
                    />
                    <FieldSelect
                      fieldId="street"
                      value={values.street}
                      placeholder="רחוב"
                      label={'רחוב'}
                      options={streets}
                      disabled={true}
                    />
                    <FieldInput fieldId="houseNumber" label="בית" disabled={true}/>
                  </div>
                  <div className={styles.fourInRow}>
                    <FieldInput fieldId="entranceNumber" label='כניסה' disabled={true}/>
                    <FieldInput fieldId="apartmentNumber" label="דירה" disabled={true}/>
                    <FieldInput
                      fieldId="salePrice"
                      dir={'ltr'}
                      ltrDirection={true}
                      value={divideThousandsIntegerValue(values.salePrice)}
                      onChange={formatStringToNumber}
                      label={'מחיר מוצהר'}
                      disabled={true}
                    />
                    <FieldInput
                      fieldId="estimatePrice"
                      dir={'ltr'}
                      ltrDirection={true}
                      value={divideThousandsIntegerValue(values.estimatePrice)}
                      onChange={formatStringToNumber}
                      label={'מחיר מוערך'}
                      disabled={true}
                    />
                  </div>
                  <div className={styles.fourInRow}>
                    <FieldInput fieldId="brutoAreaType" label="סוג שטח ברוטו" disabled={true}/>
                    <FieldInput fieldId="brutoAreaInSquareMeters" label="שטח ברוטו" disabled={true}/>
                    <FieldInput fieldId="netAreaType" label="סוג שטח נטו" disabled={true}/>
                    <FieldInput fieldId="netAreaInSquareMeters" label="שטח נטו" disabled={true}/>
                  </div>
                  <div className={styles.fourInRow}>
                    <FieldInput
                      fieldId="buildingAge"
                      onChange={limitIntegerValueLength(4)}
                      label="גיל בניין"
                      disabled={true}
                    />
                    <FieldInput fieldId="pricePerRoom" label="מחיר לחדר" disabled={true}/>
                    <FieldInput fieldId="pricePerSquareMeter" label="מחיר למטר" disabled={true}/>
                    <FieldInput fieldId="roomCount" label={'מספר חדרים'} disabled={true}/>
                  </div>
                  <div className={styles.fourInRow}>
                    <FieldInput
                      fieldId="floor"
                      onChange={limitIntegerValueLength(2)}
                      label="קומה"
                      disabled={true}
                    />
                    <FieldInput
                      fieldId="floorsCount"
                      onChange={limitIntegerValueLength(2)}
                      label="מספר קומות"
                      disabled={true}
                    />
                    <FieldInput
                      fieldId="roomsCount"
                      onChange={limitIntegerValueLength(2)}
                      label="מספר דירות בבניין"
                      disabled={true}
                    />
                  </div>
                  <div className={styles.fourInRow}>
                    <FieldInput fieldId="parking" label="חניה" disabled={true}/>
                    <FieldInput fieldId="elevator" label="מעלית" disabled={true}/>
                    <FieldInput fieldId="roof" label="גג" disabled={true}/>
                    <FieldInput fieldId="storage" label="מחסן" disabled={true}/>
                  </div>
                  <div className={styles.fourInRow}>
                    <FieldInput fieldId="yard" label="חצר" disabled={true}/>
                    <FieldInput fieldId="lot" label="מגרש" disabled={true}/>
                    <FieldInput fieldId="gallery" label="גלריה" disabled={true}/>
                    <FieldInput fieldId="sellType" label="סוג עסקה" disabled={true}/>
                  </div>
                  <div className={styles.fourInRow}>
                    <FieldInput fieldId="propertyType" label="תפקוד יחידה" disabled={true}/>
                    <FieldInput fieldId="soldShare" label="חלקים" disabled={true}/>
                    <FieldInput fieldId="essenseOfRight" label="מהות זכות" disabled={true}/>
                    <FieldInput fieldId="buildingUnitFunction" label="תפקוד בניין" disabled={true}/>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        )
      case 'surveyAssets':
        return (
          <Formik
            innerRef={formikSurveyRef}
            initialValues={{
              ...row,
              cityID: row?.cityID && Array.isArray(cities)
                ? cities.filter(item => item.value === row?.cityID)[0] : null,
              streetID: row?.streetID && Array.isArray(streets)
                ? streets.filter(item => item.value === row?.streetID)[0] : null,
              houseParking: ddOptions.filter(item => item.value === row?.houseParking)[0] ?? null,
              buildingElevator: ddOptions.filter(item => item.value === row?.buildingElevator)[0] ?? null,
              houseYard: ddOptions.filter(item => item.value === row?.houseYard)[0] ?? null,
              houseStorage: ddOptions.filter(item => item.value === row?.houseStorage)[0] ?? null,
              houseRoof: ddOptions.filter(item => item.value === row?.houseRoof)[0] ?? null
            }}
            onSubmit={() => {
            }}
            enableReinitialize={true}
          >
            {({values}) => (
              <Form>
                <div className={classNames(styles.threeInRow, styles.borderBottom)}>
                  <FieldSelect
                    fieldId="cityID"
                    value={values.cityID}
                    placeholder="עיר"
                    label={'עיר'}
                    options={cities}
                    disabled={true}
                  />
                  <FieldSelect
                    fieldId="streetID"
                    value={values.streetID}
                    placeholder="רחוב"
                    label={'רחוב'}
                    options={streets}
                    disabled={true}
                  />
                  <FieldInput fieldId="houseNum" label="בית" disabled={true}/>
                </div>
                <div className={styles.fourInRow}>
                  <FieldInput
                    fieldId="houseRegisteredArea"
                    onChange={limitFloatValueLength(6)}
                    label='שטח רשום'
                    disabled={true}
                  />
                  <FieldInput
                    fieldId="houseRoomCount"
                    onChange={limitFloatValueLength(3)}
                    label="מס' חדרים"
                    disabled={true}
                  />
                  <FieldInput
                    fieldId="floor"
                    onChange={limitIntegerValueLength(2)}
                    label="קומה"
                    disabled={true}
                  />
                  <FieldInput
                    fieldId="buildingFloorsCount"
                    onChange={limitIntegerValueLength(2)}
                    label="מס' קומות"
                    disabled={true}
                  />
                </div>
                <div className={styles.fourInRow}>
                  <FieldInput
                    fieldId="buildYear"
                    onChange={limitIntegerValueLength(4)}
                    label="שנת בניה"
                    disabled={true}
                  />
                  <FieldSelect
                    fieldId="houseParking"
                    placeholder="בחר"
                    label="חניה צמודה"
                    options={ddOptions}
                    disabled={true}
                  />
                  <FieldSelect
                    fieldId="buildingElevator"
                    placeholder="בחר"
                    label="מעלית"
                    options={ddOptions}
                    disabled={true}
                  />
                  <FieldSelect
                    fieldId="houseYard"
                    placeholder="בחר"
                    label="חצר"
                    options={ddOptions}
                    disabled={true}
                  />
                </div>
                <div className={styles.fourInRow}>
                  <FieldSelect
                    fieldId="houseStorage"
                    placeholder="בחר"
                    label="מחסן"
                    options={ddOptions}
                    disabled={true}
                  />
                  <FieldSelect
                    fieldId="houseRoof"
                    placeholder="בחר"
                    label="גג"
                    options={ddOptions}
                    disabled={true}
                  />
                  <FieldInput fieldId="houseBalconyCount" label={'שטח מגרש'} disabled={true}/>
                  <FieldInput
                    fieldId="askingPrice"
                    dir={'ltr'}
                    ltrDirection={true}
                    value={divideThousandsIntegerValue(values.askingPrice)}
                    onChange={formatStringToNumber}
                    label={'מחיר מבוקש'}
                    disabled={true}
                  />
                </div>
                <div className={classNames(styles.threeInRow, styles.borderBottom)}>
                  <FieldInput fieldId="marketingFactor" label={'הגורם המשווק'} disabled={true}/>
                </div>
              </Form>
            )}
          </Formik>
        )
      case 'firm':
      case 'shared':
      default:
        return (
          <Formik
            innerRef={formikCommonRef}
            initialValues={{
              ...row,
              officialDate: row?.officialDate ?? null,
              cityName: row?.cityName && Array.isArray(cities)
                ? cities.filter(item => item.label === row?.cityName)[0] : null,
              streetName: row?.streetName && Array.isArray(streets)
                ? streets.filter(item => item.label === row?.streetName)[0] : null,
              houseParking: ddOptions.filter(item => item.value === row?.houseParking)[0] ?? null,
              buildingElevator: ddOptions.filter(item => item.value === row?.buildingElevator)[0] ?? null,
              houseYard: ddOptions.filter(item => item.value === row?.houseYard)[0] ?? null,
              houseStorage: ddOptions.filter(item => item.value === row?.houseStorage)[0] ?? null,
              houseRoof: ddOptions.filter(item => item.value === row?.houseRoof)[0] ?? null
            }}
            onSubmit={() => {
            }}
            enableReinitialize={true}
          >
            {({values}) => (
              <Form>
                <div className={styles.threeInRow}>
                  <FieldDatepicker
                    fieldId="officialDate"
                    label={'תאריך העסקה'}
                    datepickerStyles={styles.datepicker}
                    boxStyles={styles.datepicker}
                    disabled={true}
                  />
                  <FieldInput fieldId="gush" label="גוש" disabled={true}/>
                  <FieldInput fieldId="helka" label="חלקה" disabled={true}/>
                </div>
                <div className={classNames(styles.threeInRow, styles.borderBottom)}>
                  <FieldSelect
                    fieldId="cityName"
                    value={values.cityName}
                    placeholder="עיר"
                    label={'עיר'}
                    options={cities}
                    disabled={true}
                  />
                  <FieldSelect
                    fieldId="streetName"
                    value={values.streetName}
                    placeholder="רחוב"
                    label={'רחוב'}
                    options={streets}
                    disabled={true}
                  />
                  <FieldInput fieldId="houseNum" label="בית" disabled={true}/>
                </div>
                <div className={styles.fourInRow}>
                  <FieldInput
                    fieldId="houseRegisteredArea"
                    onChange={limitFloatValueLength(6)}
                    label='שטח רשום'
                    disabled={true}
                  />
                  <FieldInput
                    fieldId="houseRoomCount"
                    onChange={limitFloatValueLength(3)}
                    label="מס' חדרים"
                    disabled={true}
                  />
                  <FieldInput
                    fieldId="floor"
                    onChange={limitIntegerValueLength(2)}
                    label="קומה"
                    disabled={true}
                  />
                  <FieldInput
                    fieldId="buildingFloorsCount"
                    onChange={limitIntegerValueLength(2)}
                    label="מס' קומות"
                    disabled={true}
                  />
                </div>
                <div className={styles.fourInRow}>
                  <FieldInput
                    fieldId="buildingAge"
                    onChange={limitIntegerValueLength(4)}
                    label="גיל בניין"
                    disabled={true}
                  />
                  <FieldSelect
                    fieldId="houseParking"
                    placeholder="בחר"
                    label="חניה צמודה"
                    options={ddOptions}
                    disabled={true}
                  />
                  <FieldSelect
                    fieldId="buildingElevator"
                    placeholder="בחר"
                    label="מעלית"
                    options={ddOptions}
                    disabled={true}
                  />
                  <FieldSelect
                    fieldId="houseYard"
                    placeholder="בחר"
                    label="חצר"
                    options={ddOptions}
                    disabled={true}
                  />
                </div>
                <div className={classNames(styles.fourInRow, styles.borderBottom)}>
                  <FieldSelect
                    fieldId="houseStorage"
                    placeholder="בחר"
                    label="מחסן"
                    options={ddOptions}
                    disabled={true}
                  />
                  <FieldSelect
                    fieldId="houseRoof"
                    placeholder="בחר"
                    label="גג"
                    options={ddOptions}
                    disabled={true}
                  />
                  <FieldInput
                    fieldId="registeredArea"
                    onBeforeInput={(e) => allowFloatWithDecimals(e, 2)}
                    label={'שטח מגרש'}
                    disabled={true}
                  />
                  <FieldInput
                    fieldId="estimatePriceFinal"
                    dir={'ltr'}
                    ltrDirection={true}
                    value={divideThousandsIntegerValue(values.estimatePriceFinal)}
                    onChange={formatStringToNumber}
                    label={'שווי'}
                    disabled={true}
                  />
                </div>
              </Form>
            )}
          </Formik>
        )
    }
  };

  return (
    <ModalCommon
      header={['הצג את הנתונים המקוריים עבור השורה', id].filter(Boolean).join(' - ')}
      customModalTrigger={<ButtonCommon icon={view} customContainerStyles={styles.buttonShow}/>}
      getDataOnOpenModal={async () => {
        await getOriginal(originID);
        if (row?.cityName || row?.city) {
          const cityID = (row?.cityName || row?.city) && Array.isArray(cities)
            ? cities.filter(item => item.label === row?.cityName || item.label === row?.city)[0].value : null;
          updateStreets(cityID)
        }
        if (row?.cityID) {
          updateStreets(row?.cityID)
        }
        setTimeout(() => {
          const valueCommon = row?.streetName && Array.isArray(streets)
            ? streets.filter(item => item.label === row?.streetName)[0] : null;
          const valueTax = row?.street && Array.isArray(streets)
            ? streets.filter(item => item.label === row?.street)[0] : null;
          const valueSurvey = row?.streetID && Array.isArray(streets)
            ? streets.filter(item => item.value === row?.streetID)[0] : null;
          formikCommonRef?.current?.setFieldValue('streetName', valueCommon);
          formikTaxAuthorityRef?.current?.setFieldValue('street', valueTax);
          formikSurveyRef?.current?.setFieldValue('streetID', valueSurvey);
        }, 2000)
      }}
    >
      <div className={styles.modalContent}>{getContent()}</div>
    </ModalCommon>
  );
};

export default ModalViewOriginalRow;